/** Creator slice lookup only; SDK validates the supplied canonical endpoint names. */
export const PILOT_ENDPOINTS = Object.freeze([
  Object.freeze({
    slice: "efficientReduxAPI",
    endpoint: "getCreatorConfig",
    name: "getcreatorconfig",
  }),
  Object.freeze({
    slice: "reduxAPI",
    endpoint: "getCreatorData",
    name: "getcreatordata",
  }),
]);
export const apiRegistry = Object.freeze({
  lookup: (slice: string, endpoint: string) =>
    PILOT_ENDPOINTS.find(
      (entry) => entry.slice === slice && entry.endpoint === endpoint
    )?.name,
});
export const API_NAMES = Object.freeze(
  PILOT_ENDPOINTS.map((entry) => entry.name)
);
